<template>
  <div class="app-container">
    <list ref="list">
        <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="primary" @click="_create" icon="el-icon-plus">添加</el-button>
            <el-button type="danger" @click="delRows">删除</el-button>
        </template>
        <template slot="column">
            <!-- <el-table-column label="操作" fixed="right" align="center" width="60"> -->
            <el-table-column label="操作" fixed="right" align="center" width="160">
                <template slot-scope="{row}">
                    <el-button v-if="$permission.canWrite()" type="text" @click="_edit(row)">编辑</el-button>
                </template>
            </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" :type="type" @close-saved="reload"></edit-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/production/craftsmanship/solutions/fittings/list'
import editDialog from '@/components/production/craftsmanship/solutions/fittings/editDialog'

export default {
  name: "fittings",
  mixins: [curdMixins],
  components: {
    list,
    editDialog
  },
  data(){
    return {
      type: 0,
    }
  },
  methods: {
    delRows(){
       this.$refs.list._del();
    },
    _create(){
      this.type = 0;
      this.create();
    },
    _edit(row){
      this.type = 1;
      this.edit(row)
    }
  }
  
};
</script>